var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content mtr-page" },
    [
      _c("div", { staticClass: "mtr-toolbar-card row-data" }, [
        _c(
          "div",
          { staticClass: "mtr-toolbar-section mtr-toolbar-section--filter" },
          [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "mtr-filter-grid" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "mtr-filter-control",
                    attrs: { placeholder: "Loại khoản", clearable: "" },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchRequest.category,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchRequest, "category", $$v)
                      },
                      expression: "searchRequest.category",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "Thu", value: "IN" } }),
                    _c("el-option", { attrs: { label: "Hoàn", value: "OUT" } }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "mtr-filter-control",
                    attrs: { placeholder: "Công thức", clearable: "" },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchRequest.hasFormula,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchRequest, "hasFormula", $$v)
                      },
                      expression: "searchRequest.hasFormula",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "Có công thức", value: true },
                    }),
                    _c("el-option", {
                      attrs: { label: "Không có công thức", value: false },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "mtr-filter-control",
                    attrs: { placeholder: "Khai báo thuế", clearable: "" },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchRequest.taxDeclaration,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchRequest, "taxDeclaration", $$v)
                      },
                      expression: "searchRequest.taxDeclaration",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "Có khai báo thuế", value: true },
                    }),
                    _c("el-option", {
                      attrs: { label: "Không khai báo thuế", value: false },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "mtr-filter-control",
                    attrs: { placeholder: "Hoá đơn điện tử", clearable: "" },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchRequest.issuingElectronicInvoices,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchRequest,
                          "issuingElectronicInvoices",
                          $$v
                        )
                      },
                      expression: "searchRequest.issuingElectronicInvoices",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "Sử dụng HĐ điện tử", value: true },
                    }),
                    _c("el-option", {
                      attrs: {
                        label: "Không sử dụng HĐ điện tử",
                        value: false,
                      },
                    }),
                  ],
                  1
                ),
                _c("el-input", {
                  staticClass: "mtr-search-input",
                  attrs: {
                    placeholder: "Nhập tên khoản thu...",
                    clearable: "",
                  },
                  on: { clear: _vm.handleSearch },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleSearch.apply(null, arguments)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("el-button", {
                            attrs: { icon: "el-icon-search" },
                            on: { click: _vm.handleSearch },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.searchRequest.keyword,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchRequest, "keyword", $$v)
                    },
                    expression: "searchRequest.keyword",
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _c("div", { staticClass: "mtr-toolbar-divider" }),
        _c(
          "div",
          { staticClass: "mtr-toolbar-section mtr-toolbar-section--action" },
          [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "mtr-action-group" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "mtr-action-button mtr-action-button--primary",
                    attrs: { type: "success" },
                    on: { click: _vm.openCreateDialog },
                  },
                  [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _vm._v("\n          Thêm mới\n        "),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "mtr-table-card row-data" }, [
        _vm._m(2),
        _c(
          "div",
          { staticClass: "mtr-table-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                staticClass: "sk-table",
                attrs: {
                  data: _vm.totalRevenueList,
                  border: "",
                  "highlight-current-row": "",
                  "max-height": _vm.$tableMaxHeightSmall,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "STT",
                    type: "index",
                    width: "55",
                    align: "center",
                    index: _vm.indexMethod,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Tên khoản thu",
                    prop: "name",
                    "min-width": "200",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "Mô tả", "min-width": "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("div", [
                            _c(
                              "div",
                              {
                                class: [
                                  "mtr-desc",
                                  {
                                    expanded: _vm.isDescriptionExpanded(row.id),
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(row.description || "—"))]
                            ),
                            _vm.showDescriptionToggle(row.description)
                              ? _c("div", { staticClass: "mtr-desc-toggle" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.toggleDescription(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.isDescriptionExpanded(row.id)
                                              ? "Thu gọn"
                                              : "Xem thêm"
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Loại", width: "85", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  row.category === "IN" ? "success" : "danger",
                                size: "mini",
                                effect: "light",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    row.category === "IN" ? "Thu" : "Hoàn"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Công thức", width: "105", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.hasFormula
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "warning",
                                    size: "mini",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-s-operation",
                                  }),
                                  _vm._v(" Có\n            "),
                                ]
                              )
                            : _c("span", { staticClass: "mtr-text-muted" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Biểu thức", "min-width": "140" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.hasFormula && row.formulaExpression
                            ? _c("span", { staticClass: "mtr-formula-badge" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.formulaExpression) +
                                    "\n            "
                                ),
                              ])
                            : _c("span", { staticClass: "mtr-text-muted" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Đơn giá", width: "145", align: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          !row.hasFormula
                            ? _c("span", { staticClass: "mtr-money" }, [
                                _vm._v(_vm._s(_vm.formatMoney(row.price))),
                              ])
                            : _c("span", { staticClass: "mtr-text-muted" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Đơn vị",
                    prop: "unit",
                    width: "90",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "SL", width: "70", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatQuantity(row.quantity)) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Giảm giá", width: "90", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("i", {
                            class: row.discount
                              ? "el-icon-circle-check"
                              : "el-icon-close",
                            style: {
                              color: row.discount ? "#16a34a" : "#dc2626",
                              fontSize: "18px",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Điểm danh", width: "100", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("i", {
                            class: row.attendance
                              ? "el-icon-circle-check"
                              : "el-icon-close",
                            style: {
                              color: row.attendance ? "#16a34a" : "#dc2626",
                              fontSize: "18px",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Chu kỳ", width: "130", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "mini",
                                effect: "plain",
                                type: "info",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.appliedTimeTypeLabel(
                                      row.appliedTimeType
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Thao tác",
                    width: "120",
                    align: "center",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: { content: "Chỉnh sửa", placement: "top" },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-edit",
                                  size: "mini",
                                  circle: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditDialog(row)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "Xóa khoản thu",
                                placement: "top",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "ml-1",
                                attrs: {
                                  type: "danger",
                                  icon: "el-icon-delete",
                                  size: "mini",
                                  circle: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row.id)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mtr-pagination" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.pagination.page,
                "page-sizes": [25, 50, 100, 200],
                "page-size": _vm.pagination.size,
                total: _vm.pagination.total,
                layout: "sizes, prev, pager, next",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.pagination, "size", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.pagination, "size", $event)
                },
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handlePageChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c("total-revenue-form-dialog", {
        ref: "formDialog",
        on: { saved: _vm.fetchData },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mtr-card-head" }, [
      _c("div", [
        _c("p", { staticClass: "mtr-card-title" }, [_vm._v("Bộ lọc tìm kiếm")]),
        _c("p", { staticClass: "mtr-card-subtitle" }, [
          _vm._v(
            "\n            Tìm nhanh khoản thu chính theo tên, loại, công thức và thuế.\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mtr-card-head mtr-card-head--compact" }, [
      _c("div", [
        _c("p", { staticClass: "mtr-card-title" }, [_vm._v("Tác vụ nhanh")]),
        _c("p", { staticClass: "mtr-card-subtitle" }, [
          _vm._v(
            "\n            Thêm mới khoản thu chính vào hệ thống.\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mtr-card-head mtr-table-head" }, [
      _c("div", [
        _c("p", { staticClass: "mtr-card-title" }, [
          _vm._v("Danh sách khoản chính"),
        ]),
        _c("p", { staticClass: "mtr-card-subtitle" }, [
          _vm._v(
            "\n          Quản lý toàn bộ khoản thu chính: đơn giá / công thức, thuế, giảm giá và điểm danh.\n        "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }